<template>
    <div id="raintoy">
        <div class="raintoy-inner">
            <div id="webgl-container">
                <div class="message" v-show="rainMsg" v-html="rainMsg">
                </div>
                <div class="button">
                    <button v-for="option in optionList" :key="option.id" @click="optionClick(option)">{{ option.label}}</button>
                </div>
                <div class="input-container">
                    <div class="img-container" v-show="imgRoute">
                        <img :src="imgRoute" />
                    </div>
                    <div class="input-inner" v-show="!onlyBtnFlag" >
                        <input id="userInput" type="text" v-model="inputMessage" placeholder="메시지를 입력하세요." @keyup.13="sendMessage('','')" />
                        <button @click="sendMessage('', '')">
                            <img src="img/landing/new/btn-send.svg" alt="보내기" />
                        </button>
                    </div>
                </div>
            </div>
<!--            <div>-->
<!--                <div id="controls"></div>-->
<!--                <div id="controls_r"></div>-->
<!--                <div id="content-container-wrap">-->
<!--                    <div id="content-container">-->
<!--                        <div class="chatbot-message">안녕하세요? <br> 저는 단비AI에서 일하고 있는 레인!<br> 챗봇 세상에 오신 것을 환영해요:)</div>-->
<!--                        &lt;!&ndash;                <div class="chatbot-buttons">&ndash;&gt;-->
<!--                        &lt;!&ndash;                    <div class="btn-choice">챗봇 세상? 더 알려줘</div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                    <div class="btn-choice">단비AI 시작하기</div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                    <div class="btn-choice">단비AI 로그인</div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->
<!--                <input type="text" v-model="inputMessage" placeholder="메시지를 입력하세요." />-->
<!--                <button @click="sendMessage()">보내기</button>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import * as THREE from '../../js/plugins/threejs/three.module.js';
import { OrbitControls } from "../../js/plugins/threejs/OrbitControls.js"
import { GLTFLoader } from "../../js/plugins/threejs/GLTFLoader.js"

export default {
    name: "raintoy",
    data(){
        return {
            inputMessage: '',
            currentChatbot: {
                chatbotId: '4b2fcd06-fd87-4ecd-80dd-b555e233ad4d',
            },
            chatMsgInfo: {
                chatMsgTxt: "",
                sessionId: "",
                chatflowId: "",
                chatInstance: "",
                chatNodeId: "",
                chatParamId: "",
                chatIntentId: ""
            },
            rainMsg: '',
            imgRoute: '',
            imgRouteTemp: '',
            optionList: [],
            onlyBtnFlag: false,
        }
    },
    methods: {
        // s : raintoy 3d model
        _setupControls() {
            const controls = new OrbitControls(this._camera, this._divContainer);
            controls.enabled = false;
            controls.enableZoom = false;  // to disable zoom
            controls.enableRotate = false; // to disable rotation
            controls.enablePan = false; // to disable pan
        },

        changeRainAnimation(animationName) {
            if(!this._animationsMap[animationName]) return;
            const previousAnimationAction = this._currentAnimationAction;
            this._currentAnimationAction = this._animationsMap[animationName];
            this._currentAnimationAction.clampWhenFinished = true;

            try {
                if ( animationName == 'land' ) {
                    this._currentAnimationAction.setLoop(THREE.LoopRepeat);
                    this._currentAnimationAction.clampWhenFinished = false;
                    this._currentAnimationAction.enable = true;
                }

                if(previousAnimationAction !== this._currentAnimationAction) {
                    previousAnimationAction.fadeOut(0.5);
                    if(animationName != 'idle') {
                        this._currentAnimationAction.setLoop(THREE.LoopOnce);
                    }
                    this._currentAnimationAction.reset().fadeIn(0.5).play();
                }
            } catch(e){}
        },
        changeToyAnimation(animationName) {
            if(!this._animationsMap1[animationName]) return;
            const previousAnimationAction = this._currentAnimationAction1;
            this._currentAnimationAction1 = this._animationsMap1[animationName];

            try {
                if(previousAnimationAction !== this._currentAnimationAction1) {
                    previousAnimationAction.fadeOut(0.5);
                    if(animationName != 'idle') {
                        this._currentAnimationAction1.setLoop(THREE.LoopOnce);
                    }
                    this._currentAnimationAction1.reset().fadeIn(0.5).play();
                }
            } catch(e){}
        },

        _setupBackgroundAnimations(gltf) {
            const model = gltf.scene;
            const mixer = new THREE.AnimationMixer(model);
            const gltfAnimations = gltf.animations;
            const domControls = document.querySelector("#controls");
            const animationsMap = {};
            let firstAnimation = '';

            gltfAnimations.forEach(animationClip => {
                const name = animationClip.name;
                // console.log(name);
                if ( firstAnimation === '' ) {
                    firstAnimation = name;
                }

                // const domButton = document.createElement("div");
                // domButton.classList.add("button");
                // domButton.innerText = name;
                // domControls.appendChild(domButton);
                //
                // domButton.addEventListener("click", () => {
                //     const animationName = domButton.innerHTML;
                //     this.changeToyAnimation(animationName);
                // });

                const animationAction = mixer.clipAction(animationClip);
                animationsMap[name] = animationAction;
            });

            this._mixer2 = mixer;
            this._animationsMap2 = animationsMap;
            this._currentAnimationAction2 =  this._animationsMap2[firstAnimation];
            try {
                this._currentAnimationAction2.play();
            } catch(e) {}
        },

        _setupRainAnimations(gltf) {
            const model = gltf.scene;
            const mixer = new THREE.AnimationMixer(model);
            const gltfAnimations = gltf.animations;
            const domControls = document.querySelector("#controls");
            const animationsMap = {};
            let firstAnimation = '';
            gltfAnimations.forEach(animationClip => {
                const name = animationClip.name;
                // console.log(name);
                if ( firstAnimation === '' ) {
                    firstAnimation = name;
                }

                // const domButton = document.createElement("div");
                // domButton.classList.add("button");
                // domButton.innerText = name;
                // domControls.appendChild(domButton);
                //
                // domButton.addEventListener("click", () => {
                //     const animationName = domButton.innerHTML;
                //     this.changeRainAnimation(animationName);
                // });

                const animationAction = mixer.clipAction(animationClip);
                animationsMap[name] = animationAction;
            });

            this._mixer = mixer;
            this._mixer.addEventListener( 'finished',(e)=>{
                // console.log(e.action._clip.name + " 끝!");
                this.changeRainAnimation('idle');
                if(e.action._clip.name === 'step-right') {
                    this._model.position.set(2.5, 2.5, 35);
                    this.changeToyAnimation('projection-start');
                    setTimeout(()=>{
                        // this.changeToyAnimation('projection-end');
                        this.imgRoute = this.imgRouteTemp;
                    }, 1000);
                } else if(e.action._clip.name === 'step-left') {
                    this._model.position.set(0, 2.5, 35);
                }
            });

            this._animationsMap = animationsMap;
            // console.log(this._animationsMap);
            //this._currentAnimationAction =  this._animationsMap[firstAnimation];
            this._currentAnimationAction =  this._animationsMap[this._currentStartAction[this._currentModelIndex][0]];
            try {
                if ( this._currentStartAction[this._currentModelIndex][0] == 'land' ) {
                    this._currentAnimationAction.setLoop(THREE.LoopOnce);
                    this._currentAnimationAction.clampWhenFinished = true;
                    this._currentAnimationAction.enable = true;
                }
                this._currentAnimationAction.play();
            } catch(e){}


            let mouse = new THREE.Vector2();
            let headMoving = false;
            this._divContainer.addEventListener('mousemove', onDocumentMouseMove.bind(this), false);
            this._divContainer.addEventListener('mouseout', onDocumentMouseOut.bind(this), false);

            let mouseInterval;
            function onDocumentMouseMove(event) {
                event.preventDefault();
                if(this._currentAnimationAction._clip.name === 'idle') {
                    headMoving = true;
                    if(mouseInterval != null) clearInterval(mouseInterval);
                    mouseInterval = setInterval(function(){
                        move(event);
                    });
                }
            }

            const move = (event) => {
                mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
                mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
                // console.log('x: ' + mouse.x, ', y: ' + mouse.y);
                if(mouse.y > 0.41) mouse.y = 0.41;
                else if(mouse.y < -0.28) mouse.y = -0.28;
                this._modelHead.rotation.x = this._modelHeadX - mouse.y;
                this._modelHead.rotation.y = this._modelHeadY + mouse.x
            }

            function onDocumentMouseOut() {
                headMoving = false;
                clearInterval(mouseInterval);
            }
        },
        _setupToyAnimations(gltf) {
            const model = gltf.scene;
            const mixer = new THREE.AnimationMixer(model);
            const gltfAnimations = gltf.animations;
            const domControls = document.querySelector("#controls");
            const animationsMap = {};
            let firstAnimation = '';
            gltfAnimations.forEach(animationClip => {
                const name = animationClip.name;
                // console.log(name);
                if ( firstAnimation === '' ) {
                    firstAnimation = name;
                }

                // const domButton = document.createElement("div");
                // domButton.classList.add("button");
                // domButton.innerText = name;
                // domControls.appendChild(domButton);
                //
                // domButton.addEventListener("click", () => {
                //     const animationName = domButton.innerHTML;
                //     this.changeToyAnimation(animationName);
                // });

                const animationAction = mixer.clipAction(animationClip);
                animationsMap[name] = animationAction;
            });

            this._mixer1 = mixer;
            this._mixer1.addEventListener( 'finished',(e)=>{
                // console.log(e.action._clip.name + " 끝!");
                this.changeToyAnimation('idle');
                if(e.action._clip.name === 'projection-start') {
                    this._modelToy.position.set(-4.9, 13, 33); // -3.6, 13, 34
                    this._modelToy.rotation.set(0.6, 0.6, 0);
                    // this.changeToyAnimation('projection');
                } else if(e.action._clip.name === 'projection-end') {
                    this._modelToy.scale.set(1.2, 1.2, 1.2);
                    this._modelToy.rotation.set(0.4, 0.2, 0.1);
                    this._modelToy.position.set(-2, 13, 31);
                } else {
                }
            });


            this._animationsMap1 = animationsMap;
            //this._currentAnimationAction =  this._animationsMap[firstAnimation];
            this._currentAnimationAction1 =  this._animationsMap1[this._currentStartAction[this._currentModelIndex][1]];
            try {
                this._currentAnimationAction1.play();
            } catch(e) {}
        },

        _setupModel() {
            const solarSystem = new THREE.Object3D();
            const rainObject = new THREE.Object3D();
            solarSystem.add(rainObject);
            this._scene.add(solarSystem);
            // const domControls = document.querySelector("#controls");
            // domControls.innerHTML = '';

            // new GLTFLoader().load("assets/raintoy/danbee-office-20220517-1611.gltf", (gltf) => {
            //     console.log(gltf);
            //     const model = gltf.scene;
            //     model.scale.set(5, 5, 5);
            //     model.position.set(0, 0, 0);
            //     this._scene.add(model);
            //     this._setupBackgroundAnimations(gltf);
            //
            //     this._modelClockL = model.getObjectByName('clock-long');
            //     this._modelClockS = model.getObjectByName('clock-short');
            // });

            new GLTFLoader().load(this._currentModel[this._currentModelIndex][0], (gltf) => {
                console.log(gltf);
                const model = gltf.scene;
                model.scale.set(6, 6, 6);
                model.position.set(0, 2.5, 35);

                model.name = 'rain_model';
                rainObject.add(model);
                // this._scene.add(model);
                // console.log(this._scene);
                this._setupRainAnimations(gltf);

                // console.log('model:');
                // console.log(model);
                this._model = model;
                this._modelHead = model.getObjectByName('mixamorigHead');
                this._modelHeadX = this._modelHead.rotation.x;
                this._modelHeadY = this._modelHead.rotation.y;

                this.getWelcomeMessage();
            });

            if ( this._currentModel[this._currentModelIndex][1] !== '' ) {
                // console.log('toy exist!!');
                new GLTFLoader().load(this._currentModel[this._currentModelIndex][1], (gltf) => {
                    // console.log(gltf);
                    const model = gltf.scene;
                    model.scale.set(1.2, 1.2, 1.2);
                    model.rotation.set(0.4, 0.2, 0.1);
                    model.position.set(-2, 13, 31);
                    model.name = 'rain_toy';
                    rainObject.add(model);
                    // this._scene.add(model);
                    this._setupToyAnimations(gltf);

                    this._modelToy = model;
                });

            } else {
                console.log('toy not found!!');
            }

            this._solarSystem = solarSystem;
        },

        _setupCamera() {
            const camera = new THREE.PerspectiveCamera(
                75,
                window.innerWidth / window.innerHeight,
                1,
                5000
            );

            camera.position.set(0, 11, 45);
            camera.lookAt(0,0,0);
            this._camera = camera;
        },

        _setupLight() {
            const color = 0xffffff;
            const intensity = 1.2;
            const light = new THREE.DirectionalLight(color, intensity);
            //light.position.set(0, 0, 1);
            light.position.set(0, 20, 20);
            this._scene.add(light);

            const ambientLight = new THREE.AmbientLight(0xFFFFDA, 1.3);
            ambientLight.position.set(0, 20, 20);
            this._scene.add(ambientLight);
        },

        update(time) {
            time *= 0.001; // second unit

            // this._solarSystem.rotation.y = time/2;
            // this._rainObject.children[0].rotation.y = time*2; // not working..
            // this._toyObject.children[0].rotation.y = time*4;

            if(this._mixer) {
                const deltaTime = time - this._previousTime;
                this._mixer.update(deltaTime);
            }
            if(this._mixer1) {
                const deltaTime = time - this._previousTime;
                this._mixer1.update(deltaTime);
            }
            if (this._modelClockL) {
                this._modelClockL.rotation.y -= 0.005;
            }
            if (this._modelClockS) {
                this._modelClockS.rotation.y -= 0.0005;
            }

            this._previousTime = time;
        },

        render(time) {
            this._renderer.render(this._scene, this._camera);
            this.update(time);

            setTimeout( () =>{
                requestAnimationFrame(this.render.bind(this));
            }, 1000 / 45 );
        },

        resize() {
            const width = this._divContainer.clientWidth;
            const height = this._divContainer.clientHeight;

            this._camera.aspect = width / height;
            this._camera.updateProjectionMatrix();

            this._renderer.setSize(width, height);
        },
        // e : raintoy 3d model


        getWelcomeMessage: async function() {
            this.chatFormFlag = false;
            this.chatFormSelectedEtcData = '';
            this.chatFormSelectedData = '';
            this.chatFormSelectedData2 = '';
            this.chatFormSelectedData3 = '';

            axios.post("https:\/\/danbee.ai/chatflow/chatbot/v2.0/" + this.currentChatbot.chatbotId + '/welcome.do', {
                channel_id: '1',
                user_id: '', // this.currentUser.userName,
                parameters: this.initParams
            }).then(res => {

                    const result = res.data.responseSet.result;
                    const resultStatus = result.resultStatus || {};

                    this.chatMsgInfo.sessionId = result.session_id;
                    this.chatMsgInfo.chatflowId = result.chatflow_id;
                    this.chatMsgInfo.chatInstance = result.ins_id;
                    this.chatMsgInfo.chatNodeId = result.node_id;
                    this.chatMsgInfo.chatParamId = result.param_id;
                    this.chatMsgInfo.chatIntentId = result.intent_id;

                    result.result.forEach((value, index) => {
                        if(index === (result.result.length-1)) {
                            // console.log(value);
                            if(value.msgBlocked && value.msgBlocked === 'Y') {
                                this.onlyBtnFlag = true;
                            } else {
                                this.onlyBtnFlag = false;
                            }
                            setTimeout(async () => {
                                await this.setChatList( value.timestamp, value.message, value.optionList, value.imgRoute, value.carouselList, value.quickList, true, value.actionData||'', true, result.log_id );
                            }, (index+1)*1000);

                        } else {
                            setTimeout(async () => {
                                await this.setChatList( value.timestamp, value.message, value.optionList, value.imgRoute, value.carouselList, value.quickList, false, value.actionData||'', true, result.log_id );
                            }, (index+1)*1000);
                        }
                    });
                },
                error => {
                    //how to handle error?
                    console.log(error);
                });
        },
        sendMessage: async function(chatbotMsg, viewSentence, parameters) {
            if (this.inputMessage === "" && viewSentence === "") {
                return false;
            }

            this.imgRoute = '';
            this.imgRouteTemp = this.imgRoute;
            this.optionList = [];

            //set chat message set for sending
            var chatMsg = {};

            // console.log(this.selectableResult);
            // console.log(this.lastOptionList);

            if (chatbotMsg != "") {
                //click event
                chatMsg = chatbotMsg;
            } else {
                //일반 message 전송
                chatMsg.session_id = this.chatMsgInfo.sessionId;
                chatMsg.chatbot_id = this.currentChatbot.chatbotId;
                chatMsg.user_id = '', // this.currentUser.userName;
                chatMsg.input_sentence = this.inputMessage;
                chatMsg.ins_id = this.chatMsgInfo.chatInstance;
                chatMsg.intent_id = this.chatMsgInfo.chatIntentId;
                chatMsg.chatflow_id = this.chatMsgInfo.chatflowId;
                chatMsg.node_id = this.chatMsgInfo.chatNodeId;
                chatMsg.param_id = this.chatMsgInfo.chatParamId;
            }
            //user chat message push
            chatMsg.parameters = {};
            // this.scrollDown();
            Object.assign(chatMsg.parameters, this.initParams);

            // 1 : Frogue 로 셋팅
            chatMsg.channel_id = '1';
            //message send
            // this.setChatbotTypingIndicatorFlag(true);
            axios.post("https:\/\/danbee.ai/chatflow/chatbot/v2.0/" + this.currentChatbot.chatbotId + '/message.do', chatMsg).then( res => {
                    this.initChatMsgInfo();
                    // this.initSelectableResult();

                    const result = res.data.responseSet.result;
                    const resultStatus = result.resultStatus || {};

                    this.chatMsgInfo.sessionId = result.session_id;
                    this.chatMsgInfo.chatflowId = result.chatflow_id;
                    this.chatMsgInfo.chatInstance = result.ins_id;
                    this.chatMsgInfo.chatNodeId = result.node_id;
                    this.chatMsgInfo.chatParamId = result.param_id;
                    this.chatMsgInfo.chatIntentId = result.intent_id;

                    const mainResult = result.result;
                    if ( mainResult !== undefined && mainResult.length > 0 && (result.another_result === undefined || result.another_result.length == 0) ) {
                        //result만 있는 경우

                        mainResult.forEach((value, index) => {
                            if(index === (result.result.length-1)) {
                                // console.log(value);
                                if(value.msgBlocked && value.msgBlocked === 'Y') {
                                    this.onlyBtnFlag = true;
                                } else {
                                    this.onlyBtnFlag = false;
                                }
                                setTimeout(async () => {
                                    await this.setChatList( value.timestamp, value.message, value.optionList, value.imgRoute, value.carouselList, value.quickList, true, value.actionData||'', false, result.log_id );
                                }, (index+1)*1000);

                            } else {
                                setTimeout(async () => {
                                    await this.setChatList( value.timestamp, value.message, value.optionList, value.imgRoute, value.carouselList, value.quickList, false, value.actionData||'', false, result.log_id );
                                }, (index+1)*1000);
                            }
                        });
                    } else if ( result.another_result !== undefined && result.another_result.length > 0 ) {
                        // 애매한 경우 관련 메시지를 채팅창에 나열한다.
                        this.rainMsg = result.result[0].message;
                        // setTimeout(async () => {
                        //     await this.setAskBackMsg(result.another_result, result.result[0].message);
                        // }, 2000);
                    }
                },
                error => {
                    //how to handle error?
                    console.log(error);
                });
            this.inputMessage = "";
        },
        setChatList: async function( messagetimestamp, message, optionList, imgRoute, carouselList, quickList, lastFlag, actionData, isWelcome, log_id ) {
            //empty message
            if ( message == "" && optionList.length == 0 && imgRoute == "" && carouselList.length == 0 ) {
                // this.setChatbotTypingIndicatorFlag(false);
                return false;
            }

            // console.log("imgRoute:" + imgRoute);
            this.rainMsg = message;

            if(lastFlag) {
                if(optionList.length > 0) {
                    this.optionList = optionList.splice(0, 3);
                }
                if(imgRoute) {
                    this.imgRouteTemp = imgRoute;
                    this.changeRainAnimation("step-right");
                }
            }

            if ( actionData ) {
                this.changeRainAnimation(actionData);
                this.changeToyAnimation(actionData);
            }
        },
        // setAskBackMsg: async function(anotherResult, message, ) {
        //     this.setQuickReplyBtnFlag(false, []);
        //     var timeId = moment();
        //     this.selectableResult.type = "intent";
        //     this.selectableResult.list = anotherResult;
        //
        //     var resInput = {
        //         type: "askBack",
        //         sentence: message,
        //         timestamp: moment().format("a h:mm"),
        //         timeId: timeId,
        //         intentList: anotherResult,
        //         profileImgRoute: this.currentChatbotProfileImage,
        //     };
        //
        //     this.setChatbotTypingIndicatorFlag(false);
        //     this.chatList.push(resInput);
        //
        //     this.scrollDown();
        // },
        initChatMsgInfo: function() {
            this.chatMsgInfo.chatMsgTxt = "";
            this.chatMsgInfo.sessionId = "";
            this.chatMsgInfo.chatflowId = "";
            this.chatMsgInfo.chatInstance = "";
            this.chatMsgInfo.chatNodeId = "";
            this.chatMsgInfo.chatParamId = "";
            this.chatMsgInfo.chatIntentId = "";
        },
        optionClick(option) {
            // console.log(option);
            switch (option.type) {
                case "btn":
                    this.inputMessage = option.value;
                    this.sendMessage('', '');
                    break;
                case "callFlow":
                    break;
                case "call": //임시
                    break;
                case "quick":
                    break;
                case "action":
                    break;
                case 'callNode' :
                    break;
                case 'link':
                    if ( option.value && option.value.startsWith('mailto:') ) {
                        var emailElement = document.createElement('a');
                        emailElement.setAttribute('type', 'hidden');
                        emailElement.setAttribute('href', option.value);
                        emailElement.setAttribute('target', '_blank');
                        emailElement.click();
                    } else {
                        var emailElement = document.createElement('a');
                        emailElement.setAttribute('type', 'hidden');
                        emailElement.setAttribute('href', option.value);
                        emailElement.setAttribute('target', '_blank');
                        emailElement.click();
                    }
                    this.inputMessage = "";
                    break;
                default:
                    break;
            }
        },
    },
    watch: {
        imgRoute: function(newVal, oldVal) {
            if(oldVal && !newVal) {
                this.changeRainAnimation('step-left');
                this.changeToyAnimation('projection-end');
                // this._modelToy.position.set(-3.6, 13, 34);
                // this.changeToyAnimation('idle');
            }
        }
    },
    mounted() {
        const divContainer = document.querySelector("#webgl-container");
        this._divContainer = divContainer;

        this._currentModelIndex = 2;
        this._currentModel = [
            ['assets/raintoy/20220421-rain-coat-newblend-animation-mix2.gltf',''],
            ['assets/raintoy/ubee-03-smallsize-animation.gltf', ''],
            ['assets/raintoy/rain.gltf', 'assets/raintoy/toy.gltf']
        ];
        // rain-color-animation-map , rain-20220516-1802

        this._currentStartAction = [
            ['armwave',''],
            ['test',''],
            ['land','idle']
        ];

        const renderer = new THREE.WebGLRenderer({ antialias: true,  alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        divContainer.appendChild(renderer.domElement);

        this._renderer = renderer;

        const scene = new THREE.Scene();
        // scene.background = new THREE.Color(0xffffff);
        this._scene = scene;

        this._setupCamera();
        this._setupLight();
        this._setupModel();
        this._setupControls();

        window.onresize = this.resize.bind(this);
        this.resize();

        requestAnimationFrame(this.render.bind(this));
    }
}
</script>

<style scoped>
#raintoy, .raintoy-inner {
    height: inherit;
}

.raintoy-inner {
    background-image: url("../../img/rain/rain_bg.png");
    background-size: cover;
    background-position: center bottom;
}

#webgl-container, #webgl-container > canvas {
     width:100%;
     height:100%;
}

#webgl-container {
    display: flex;
    flex-direction: column;
}

.message{
    position: absolute;
    bottom: 200px;
    left: 50%;
    display: block;
    width: fit-content;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    background: rgba(255,255,255,0.7);
    color: #494343;
    border-radius: 10px;
    padding: 10px 30px;
    margin-right: 10px;
}

.button {
    position: absolute;
    left: 50%;
    bottom: 80px;
    text-align: center;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 1;
}

.button button{
    display: block;
    width: 243px;
    font-size: 20px;
    text-align: left;
    background: #515794;
    color: #fff;
    border: 3px solid #515794;
    border-radius: 12px;
    cursor: pointer;
    padding: 6px 14px;
    margin: 4px 0;
}

.input-container {
    position: absolute;
    left: 50%;
    bottom: 36px;
    width: fit-content;
    min-width: 300px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    margin: auto;
}
.img-container {
    position: absolute;
    left: 50%;
    bottom: 250px;
    max-width: 260px;
    width: 100%;
    height: 260px;
    object-fit: contain;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}
.img-container img {
    width: fit-content;
    height: 100%;
}
.input-inner {
    display: flex;
    align-items: center;
    border: 3px solid #515794;
    border-radius: 12px;
    background: #fff;
}
.input-inner input {
    width: calc(100% - 30px);
    padding: 10px;
    font-size: 16px;
    border: 0;
    border-radius: 12px;
}
.input-inner input:focus {
    outline: none;
}
.input-inner button {
    background: transparent;
    border: none;
    cursor: pointer;
}
.input-inner img {
    width: 24px;
    height: 24px;
    fill: #FFC92A;
}

@media (max-width: 462px) {
    .input-container {
        width: calc(100% - 160px);
        min-width: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/raintoy/raintoy.vue?74085dbf